import { Map } from 'immutable';
import createSelector from '../../utils/reselect';

const getAuthentication = (state: any) => {
    const { authentication } = state;

    return authentication || Map();
};

export const getAuthenticationContext = createSelector(getAuthentication, (state) => {
    return state.getIn(['context']);
});

export const getScopes = createSelector(getAuthentication, (state) => {
    return state.getIn(['scopes']);
});

export const getLoggedInUser = createSelector(getAuthentication, (state) => {
    return state.getIn(['context', 'accountInfo', 'account']);
});
